module.exports = __webpack_public_path__ + "static/media/audible.eecab4d6.png";